// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-map-Map-module__contextMenu {
    z-index: 3;
}

.src-map-Map-module__mapContainer {
    height: 100%;
    width: 100%;
}

.src-map-Map-module__customZoom {
    right: 17px;
    top: 115px;
}

@media (max-width: 44rem) {
    .src-map-Map-module__customZoom {
        top: unset;
        bottom: 0.5em;
    }
}

/* changing the position of the attribution is a bit complex as we have to repeat the other css */
.src-map-Map-module__customAttribution {
    left: 0;
    bottom: 0;
    padding: 1px 5px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0 4px 0 0;
}

.src-map-Map-module__customAttribution ul {
    font-size: 12px;
}

.src-map-Map-module__customAttribution a {
    padding-right: 3px;
    color: rgba(0, 60, 136, 0.7);
    text-decoration: none;
}

.src-map-Map-module__customAttribution button {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/map/Map.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA,iGAAiG;AACjG;IACI,OAAO;IACP,SAAS;IACT,gBAAgB;IAChB,0CAA0C;IAC1C,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".contextMenu {\n    z-index: 3;\n}\n\n.mapContainer {\n    height: 100%;\n    width: 100%;\n}\n\n.customZoom {\n    right: 17px;\n    top: 115px;\n}\n\n@media (max-width: 44rem) {\n    .customZoom {\n        top: unset;\n        bottom: 0.5em;\n    }\n}\n\n/* changing the position of the attribution is a bit complex as we have to repeat the other css */\n.customAttribution {\n    left: 0;\n    bottom: 0;\n    padding: 1px 5px;\n    background-color: rgba(255, 255, 255, 0.8);\n    border-radius: 0 4px 0 0;\n}\n\n.customAttribution ul {\n    font-size: 12px;\n}\n\n.customAttribution a {\n    padding-right: 3px;\n    color: rgba(0, 60, 136, 0.7);\n    text-decoration: none;\n}\n\n.customAttribution button {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contextMenu": `src-map-Map-module__contextMenu`,
	"mapContainer": `src-map-Map-module__mapContainer`,
	"customZoom": `src-map-Map-module__customZoom`,
	"customAttribution": `src-map-Map-module__customAttribution`
};
export default ___CSS_LOADER_EXPORT___;
